export var SimpleFormIteratorPrefix = 'RaSimpleFormIterator';
export var SimpleFormIteratorClasses = {
    line: "".concat(SimpleFormIteratorPrefix, "-line"),
    index: "".concat(SimpleFormIteratorPrefix, "-index"),
    inline: "".concat(SimpleFormIteratorPrefix, "-inline"),
    indexContainer: "".concat(SimpleFormIteratorPrefix, "-indexContainer"),
    form: "".concat(SimpleFormIteratorPrefix, "-form"),
    action: "".concat(SimpleFormIteratorPrefix, "-action"),
    leftIcon: "".concat(SimpleFormIteratorPrefix, "-leftIcon"),
};
//# sourceMappingURL=useSimpleFormIteratorStyles.js.map